import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {getPage, selectUserAPI} from './myApi';

const initialState = {
    pageContent: [],
    status: 'loading',
}

export const fetchPage = createAsyncThunk(
    'list/fetchPage',
    async (queryParam) => {
        const response = await getPage(queryParam);
        if (response.error) {
            throw new Error(response.error);
        }
        return response.data;
    }
);
export const fetchSelectUser = createAsyncThunk(
    'list/fetchSelectUser',
    async (queryParam) => {
        const response = await selectUserAPI(queryParam);
        if (response.error) {
            throw new Error(response.error);
        }
        return response.data;
    }
);

export const listSlice = createSlice({
    name: 'list',
    initialState,
    reducers: {
        clearList: (state) => {
            state.list = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPage.fulfilled, (state, action) => {
                state.status = 'idle';
                    if (action.payload != null && action.payload.partyCards != null && action.payload.partyCards != undefined && action.payload.partyCards.length === 1) {
                        state.status = 'redirect'
                    }
                    state.pageContent = action.payload;
                    if (action.payload != null && action.payload.errorMsg != null && action.payload.errorMsg != undefined) {
                        state.pageContent = {
                            errorDTO: {
                                id: 0,
                                title: 'Hoppá!',
                                body: 'Felhasználóid összerendelése folyamatban van. Kérjük, próbálkozz újra később!',
                                redirectUrl: action.payload.errorMsg,
                                buttonText: action.payload.buttonText
                            }
                        };
                        state.error = action.error;
                    }
            })
            .addCase(fetchSelectUser.pending, (state, action) => {
                state.status = 'redirect';
            })
            .addCase(fetchSelectUser.fulfilled, (state, action) => {
                state.status = 'idle';
                state.pageContent = action.payload;
            })
            .addCase(fetchPage.rejected, (state, action) => {
                state.status = 'idle';
                //state.pageContent = [];
                state.pageContent = {
                    errorDTO: {
                        id: 0,
                        title: 'Hoppá!',
                        body: 'Felhasználóid összerendelése folyamatban van. Kérjük, próbálkozz újra később!'
                    }
                };
                state.error = action.error;
            })
    }
});

export const getPageContent = (state) => state.list.pageContent;
export const getStatus = (state) => state.list.status;
export default listSlice.reducer;
